<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Payroll History of {{ employeeName }}</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">
            <a [routerLink]="[eps.hrm.employeePath, employeeId]">Employee</a>
          </li>
          <li class="breadcrumb-item" aria-current="page">Payroll History</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2">
      <!--<h2>1/3</h2>-->
    </div>
  </div>
  <!-- /Breadcrumb -->
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="dropdown me-3">
          <select id="financialYear" [formControl]="selectedFinancialYear" class="form-select">
            <option value="" selected disabled>Select Financial Year</option>
            <!-- <option *ngFor="let year of financialYears" [value]="year">{{ year }}</option> -->
            <option *ngFor="let year of financialYears$ | async" [value]="year.name">
              {{ year.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- <ng-container *ngIf="loading$ | async; else dataTpl"> Loading... </ng-container> -->
  <!-- <ng-template #dataTpl> -->
  <div
    class="accordions-items-seperate"
    id="accordionSpacingExample"
    *ngIf="selectedFinancialYear.value"
  >
    <ng-container *ngIf="payrollSummary$ | async as payrollSummary">
      <div
        class="accordion-item"
        *ngIf="
          payrollSummary.past &&
          ((payrollSummary.past.earningsRows?.length || 0) > 0 ||
            (payrollSummary.past.deductionsRows?.length || 0) > 0 ||
            (payrollSummary.past.totals?.net?.values?.length || 0) > 0 ||
            (payrollSummary.past.totals?.gross?.values?.length || 0) > 0)
        "
      >
        <h2 class="accordion-header" id="headingSpacingOne">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#SpacingOne"
            aria-expanded="true"
            aria-controls="SpacingOne"
          >
            Past Months
          </button>
        </h2>
        <div
          id="SpacingOne"
          class="accordion-collapse collapse show"
          aria-labelledby="headingSpacingOne"
          data-bs-parent="#accordionSpacingExample"
        >
          <div class="accordion-body">
            <!--Payroll historical data-->
            <div class="table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Salary Heads</th>
                    <th *ngFor="let col of (payrollSummary$ | async)?.past?.header" scope="col">
                      {{ col }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="fw-bold">--- Earnings ---</td>
                  </tr>
                  <tr *ngFor="let row of (payrollSummary$ | async)?.past?.earningsRows">
                    <td>{{ row.componentName }}</td>
                    <td *ngFor="let colVal of row.values">
                      {{ colVal | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">--- Deductions ---</td>
                  </tr>
                  <tr *ngFor="let row of (payrollSummary$ | async)?.past?.deductionsRows">
                    <td>{{ row.componentName }}</td>
                    <td *ngFor="let colVal of row.values">
                      {{ colVal | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                    </td>
                  </tr>
                  <!-- <tr>
                  <td class="fw-bold">--- TDS ---</td>
                </tr> -->
                  <tr *ngFor="let row of (payrollSummary$ | async)?.past?.tdsRows">
                    <td>{{ row.componentName }}</td>
                    <td *ngFor="let colVal of row.values">
                      {{ colVal | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                    </td>
                  </tr>
                  <!-- <tr>
                  <td class="fw-bold">--- LOP Days ---</td>
                </tr> -->
                  <tr *ngFor="let row of (payrollSummary$ | async)?.past?.lopRows">
                    <td>{{ row.componentName }}</td>
                    <td *ngFor="let colVal of row.values">
                      {{ colVal }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">
                      {{ (payrollSummary$ | async)?.past?.totals?.net?.componentName }}
                    </td>
                    <td *ngFor="let colVal of (payrollSummary$ | async)?.past?.totals?.net?.values">
                      {{ colVal | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">
                      {{ (payrollSummary$ | async)?.past?.totals?.gross?.componentName }}
                    </td>
                    <td
                      *ngFor="let colVal of (payrollSummary$ | async)?.past?.totals?.gross?.values"
                    >
                      {{ colVal | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div
        class="accordion-item"
        *ngIf="
          payrollSummary.future &&
          ((payrollSummary.future.earningsRows?.length || 0) > 0 ||
            (payrollSummary.future.deductionsRows?.length || 0) > 0 ||
            (payrollSummary.future.totals?.net?.values?.length || 0) > 0 ||
            (payrollSummary.future.totals?.gross?.values?.length || 0) > 0)
        "
      >
        <h2 class="accordion-header" id="headingSpacingTwo">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#SpacingTwo"
            aria-expanded="false"
            aria-controls="SpacingTwo"
          >
            Future Months
          </button>
        </h2>
        <div
          id="SpacingTwo"
          class="accordion-collapse collapse"
          aria-labelledby="headingSpacingTwo"
          data-bs-parent="#accordionSpacingExample"
        >
          <div class="accordion-body">
            <!--Payroll Future data-->
            <div class="table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Salary Heads</th>
                    <th *ngFor="let col of (payrollSummary$ | async)?.future?.header" scope="col">
                      {{ col }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="fw-bold">--- Earnings ---</td>
                  </tr>
                  <tr *ngFor="let row of (payrollSummary$ | async)?.future?.earningsRows">
                    <td>{{ row.componentName }}</td>
                    <td *ngFor="let colVal of row.values">
                      {{ colVal | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">--- Deductions ---</td>
                  </tr>
                  <tr *ngFor="let row of (payrollSummary$ | async)?.future?.deductionsRows">
                    <td>{{ row.componentName }}</td>
                    <td *ngFor="let colVal of row.values">
                      {{ colVal | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">
                      {{ (payrollSummary$ | async)?.future?.totals?.net?.componentName }}
                    </td>
                    <td
                      *ngFor="let colVal of (payrollSummary$ | async)?.future?.totals?.net?.values"
                    >
                      {{ colVal | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">
                      {{ (payrollSummary$ | async)?.future?.totals?.gross?.componentName }}
                    </td>
                    <td
                      *ngFor="
                        let colVal of (payrollSummary$ | async)?.future?.totals?.gross?.values
                      "
                    >
                      {{ colVal | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- </ng-template> -->
</div>
